<script>
    import _ from 'lodash'
    import * as types from '../store/types'

    export default {
        computed: {
            user () {
                return this.$store.getters[types.users.modules.current.getters.item]
            }
        },
        created () {
            this.$emit('created', this.user)
        },
        mounted () {
            this.$emit('success', this.user)
        },
        render () {
            return this.$scopedSlots.default({
                data: _.get(this.user, 'data')
            })
        }
    }
</script>
